//  ----------      START   IMPORT  BLOCK       ----------
import { useState } from 'react';
//  Widgets
import { Form, InputGroup, Dropdown, Row, Col } from 'react-bootstrap';
//  Config
import { VocabDentistry } from '../../../ConfigFiles/multilingual/VocabDentistry';
import './FilterDropdown.css';
//  ----------      END   IMPORT  BLOCK       ----------

const FilterDropdown = ({ selectedTeeth, setSelectedTeeth, lan, toothOptions }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleCheckboxChange = (tooth) => {
    setSelectedTeeth((prevSelected) => {
      if (tooth === 'all') {
        // If "All" is selected, reset to all teeth
        return prevSelected.includes('all') ? [] : ['all'];
      }

      // If specific tooth is selected
      const isSelected = prevSelected.includes(tooth);

      // Add or remove tooth from selection
      const updatedSelection = isSelected
        ? prevSelected.filter((id) => id !== tooth && id !== 'all')
        : [...prevSelected.filter((id) => id !== 'all'), tooth];

      return updatedSelection;
    });
  };

  const handleToggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <InputGroup className="filter-dropdown-container">
      <InputGroup.Text>{VocabDentistry.filter[lan]}</InputGroup.Text>
      <Dropdown show={showDropdown} onToggle={handleToggleDropdown}>
        <Dropdown.Toggle
          variant="outline-secondary"
          id="filter-dropdown"
          onClick={handleToggleDropdown}
        >
          {selectedTeeth.includes('all')
            ? VocabDentistry.all_teeth[lan]
            : selectedTeeth.join(', ')}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {/* Render "All" option in its own row */}
          <Row className="filter-row">
            <Col xs={12}>
              <Form.Check
                type="checkbox"
                id="checkbox-all"
                label={VocabDentistry.all_teeth[lan]}
                checked={selectedTeeth.includes('all')}
                onChange={() => handleCheckboxChange('all')}
              />
            </Col>
          </Row>
          <hr /> {/* Optional separator */}
          {/* Render other tooth options */}
          <Row>
            {toothOptions
              .filter((tooth) => tooth !== 'all')
              .map((tooth) => (
                <Col xs={6} md={3} key={tooth}>
                  <Form.Check
                    type="checkbox"
                    id={`checkbox-${tooth}`}
                    label={`${VocabDentistry.tooth[lan]} ${tooth}`}
                    checked={selectedTeeth.includes(tooth)}
                    onChange={() => handleCheckboxChange(tooth)}
                  />
                </Col>
              ))}
          </Row>
        </Dropdown.Menu>
      </Dropdown>
    </InputGroup>
  );
};

export default FilterDropdown;